import {
  extractData,
  extractDataWithMeta,
} from "@shared/utils/extract-dto-data";
import { safeParseWithFallback } from "@shared/utils/safe-parse-with-fallback";

import {
  EquipmentsPageDtoSchema,
  EquipmentsPointDtoSchema,
  EquipmentTypesDtoSchema,
} from "./schemas";
import type {
  EquipmentPoints,
  EquipmentsPageType,
  EquipmentType,
} from "./types";

const defaultMeta = {
  pagination: { page: 1, pageSize: 0, pageCount: 0, total: 0 },
};

export const mapDtoToEquipmentPage = (dto: unknown): EquipmentsPageType => {
  const parsed = safeParseWithFallback(
    EquipmentsPageDtoSchema,
    dto,
    "mapDtoToEquipmentPage",
  );

  return extractData(parsed, dto, dto as EquipmentsPageType);
};

export const mapDtoToEquipmentPoints = (dto: unknown): EquipmentPoints => {
  const parsed = safeParseWithFallback(
    EquipmentsPointDtoSchema,
    dto,
    "mapDtoToEquipmentPoints",
  );

  return extractDataWithMeta<EquipmentPoints["data"], EquipmentPoints["meta"]>(
    parsed,
    dto,
    defaultMeta as EquipmentPoints["meta"],
  );
};

export const mapDtoToEquipmentTypes = (dto: unknown): EquipmentType[] => {
  const parsed = safeParseWithFallback(
    EquipmentTypesDtoSchema,
    dto,
    "mapDtoToEquipmentTypes",
  );

  return extractData(parsed, dto, []);
};
